var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"teaser",staticClass:"teaser"},[(_vm.giftBoxBannerVisible)?_c('GiftBoxBanner'):_vm._e(),_vm._v(" "),_c('ImageFluid',{staticClass:"teaser-image",attrs:{"src":_vm.url,"alt":_vm.alt,"eager":_vm.forceLoad,"width":_vm.width,"height":_vm.height}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }